export const getOperatorName = ({login, name}) => {
  if (login && name) {
    return `${name} (${login})`;
  }
  return login;
}
